export interface IAspect {
    id: number;
    pmv_id?: number;
    pictogram: string;
    line1: string;
    line2: string;
    line3: string;
    textAlign: 'center' | 'left' | 'right';
    created_at?: string;
    updated_at?: string;
}

export interface IAspectStore {
    pictogram: string;
    line1: string;
    line2: string;
    line3: string;
    textAlign: 'center' | 'left' | 'right';
}

export interface IPmv {
    id: number;
    package_id?: number;
    description: string;
    aspects: IAspect[];
    created_at?: string;
    updated_at?: string;
}

export interface IPMVStore {
    package_id: number;
    description: string;
    aspects: IAspectStore[];
}

export const initialIPmv: IPmv = {
    id: 0,
    package_id: 0,
    aspects: [],
    description: '',
}

export interface IIndexParamsPmv {
    package_id: number;
    page?: number;
    pageSize?: number;
}

export interface IIndexResponsePmv {
    data: IPmv[];
    totalItems: number;
    error: boolean;
}

export interface IStoreParamsPmv {
    package_id: number;
    description: string;
    aspects: IAspectStore[];
}

export interface IStoreResponsePmv {
    message: string;
    status: number | boolean;
    data: IPmv;
}

export interface IPMVStatus {
    id: number;
    pmv_id: number;
    message: string;
    pmv: IPmv;
    created_at?: string;
    is_online: boolean;
}

export interface IPMVStatusIndexParams {
    page?: number;
    pageSize?: number;
    orderBy?: 'asc' | 'desc';
    startDate?: string;
    endDate?: string;
}